import {storeView, StoreView} from "./view/IInvestStoreViewComponent";
import {IInvestStoreService} from "./service/IInvestStoreService";
import Components from "./components";

export default function(parentDir: string) {

    const rootDir = `${parentDir}/iinvest`;

    return angular.module("tfApp.store.iinvest", [Components(rootDir)])
                  .component(StoreView, storeView(rootDir))
                  .service(IInvestStoreService.id, IInvestStoreService)
                  .name;
}
